import MaterialIcon from "../../../../../MaterialIcon";
import React from "react";

export const SearchButton = () => {
  return (
      <button type="submit" className="search-button editorial-field">
          <MaterialIcon icon="search"/>
      </button>
  )
}